const app = angular.module('msi.oneTimeDifferences.oneTimeDifferencesExplanationController', []);

function oneTimeDifferencesExplanationController(shipment, $translate) {
  const ctrl = this;

  ctrl.shipment = shipment;

  ctrl.productQuantityDifferences = ctrl.shipment.oneTimeDifferences.quantityDifferences;

  ctrl.productsByDifferentPayments = ctrl.shipment.oneTimeDifferences.productsByDifferentPayments;

  ctrl.productsByDifferentShipping = ctrl.shipment.oneTimeDifferences.productsByDifferentShipping;

  ctrl.translateProductsList = function(items) {
    return $translate.instant('PLURAL_PRODUCT_LIST', { items });
  };
}

oneTimeDifferencesExplanationController.$inject = ['shipment', '$translate'];

app.controller('oneTimeDifferencesExplanationController', oneTimeDifferencesExplanationController);

module.exports = app.name;
